import * as React from 'react';
import CustomTooltip from '../CustomTooltip';
import useTooltip from '../hooks/useTooltip';

interface ICustomer {
  id: number;
  name: string;
  label: string | null;
}

interface ICustomersCellProps {
  customers: ICustomer[];
  align?: string;
  tooltipEnabled?: boolean;
}

function CustomersCell(props: ICustomersCellProps): JSX.Element {
  const { hover, tooltipPos, textRef, handleMouseEnter, handleMouseLeave } = useTooltip();

  const alignClass = props.align || 'left';

  if (!props.customers) {
    return (
      <div
        className={`align-${alignClass}`}
        style={{
          whiteSpace: 'nowrap',
          flex: 1,
        }}
      />
    );
  }

  const tooltipContent = () => (
    <div style={{ color: '#fff', whiteSpace: 'nowrap' }}>
      {props.customers.map((customer: ICustomer) => (
        <React.Fragment key={`customer-cell-item-tooltip-${customer.id}`}>
          {customer.name}
          <br />
        </React.Fragment>
      ))}
    </div>
  );

  const isTextTruncated = () => {
    if (!textRef.current) return false;
    return textRef.current.offsetWidth < textRef.current.scrollWidth;
  };

  const showTooltip = (hover && (isTextTruncated() || props.tooltipEnabled)) ?? false;

  return (
    <div
      className={`text-cell align-${alignClass}`}
      style={{
        whiteSpace: 'nowrap',
        flex: 1,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CustomTooltip content={tooltipContent()} show={showTooltip} position={tooltipPos}>
        <div className="text-cell" ref={textRef}>
          {props.customers.map((customer: ICustomer, index: number) => (
            <span className="text-black" key={`customer-cell-item-${customer.id}`}>
              {customer.label}
              {index < props.customers.length - 1 ? ', ' : ''}
            </span>
          ))}
        </div>
      </CustomTooltip>
    </div>
  );
}

export default CustomersCell;
